<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eXa2LR/tc-custom/9780226776316.jpg?1726518954722" alt="This image is the cover for the book Climate and the Making of Worlds"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Climate and the Making of Worlds
      </h1>
      <p class="bookDescription body article font2">
        <b>Winner of the Society for Literature, Science, and the Arts Michelle Kendrick Memorial Book Prize and the Center for Robert Penn Warren Studies Warren-Brooks Award. </b><br/><br/> In this book, Tobias Menely develops a materialist ecocriticism, tracking the imprint of the planetary across a long literary history of poetic rewritings and critical readings which continually engage with the climate as a condition of human world making. Menely’s central archive is English poetry written between John Milton’s <i>Paradise Lost</i> (1667) and Charlotte Smith’s “Beachy Head” (1807)—a momentous century and a half during which Britain, emerging from a crisis intensified by the Little Ice Age, established the largest empire in world history and instigated the Industrial Revolution. Incorporating new sciences into ancient literary genres, these ambitious poems aspired to encompass what the eighteenth-century author James Thomson called the “system . . . entire.” Thus they offer a unique record of geohistory, Britain’s epochal transition from an agrarian society, buffeted by climate shocks, to a modern coal-powered nation. <i>Climate and the Making of Worlds</i> is a bracing and sophisticated contribution to ecocriticism, the energy humanities, and the prehistory of the Anthropocene.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tobias Menely
      </h2>
      
      <p class="authorDescription body article"><B>Tobias Menely</B> is professor of English at the University of California, Davis. He is the author of <I>The Animal Claim: Sensibility and the Creaturely Voice</I>, also published by the University of Chicago Press.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?10d32bff